// extracted by mini-css-extract-plugin
module.exports = {"container":"legacy-clp-layout-container_container__iRVXW"};